import React, {useContext} from 'react';
import { Context } from './Context';
import Prism from './animations/Prism';
import Helix from './animations/Helix';
import Darklight from './animations/Darklight';
import Leafdance from './animations/Leafdance';


const AnimationRadio = () => {
    const { animation, handleRadioSelection } = useContext(Context)
    return (
        <div className="design-container">
            <div>                                            
                {animation==='prism' && <Prism numCol={5} numRow={5}/>}
                {animation==='helix' && <Helix num={25}/>}
                {animation==='darklight' && <Darklight num={40}/>}
                {animation==='leafdance' && <Leafdance num={18}/>}
            </div> 

            <p className="radioHeader">Designs created with SASS and React</p>
            <div className="radioBtnContainer">
                <div>
                    <label>
                        <input  type="radio" 
                                name="animation" 
                                value="prism" 
                                checked={animation==="prism"} 
                                onChange={handleRadioSelection} />
                    Prism</label>
                </div>
                <div>
                    <label>
                        <input  type="radio" 
                                name="animation" 
                                value="helix" 
                                checked={animation==="helix"} 
                                onChange={handleRadioSelection} />
                    Helix</label>
                </div>

                <div>
                    <label>
                        <input  type="radio" 
                                name="animation" 
                                value="darklight" 
                                checked={animation==="darklight"} 
                                onChange={handleRadioSelection} />
                    Darklight</label>
                </div>
                <div>
                    <label>
                        <input  type="radio" 
                                name="animation" 
                                value="leafdance" 
                                checked={animation==="leafdance"} 
                                onChange={handleRadioSelection} />
                    Leafdance</label>
                </div>
                <div>
                    <label>
                        <input  type="radio" 
                                name="animation" 
                                value="hide" 
                                checked={animation==="hide"} 
                                onChange={handleRadioSelection} />
                    None</label>
                </div>

            </div>	
            <br />

        </div>
    )
}

export default AnimationRadio;